import React, { lazy } from "react"; 

const Dashboard = lazy(() => import("../pages/common/Dashboard"));
const ChangePassword = lazy(() => import("../pages/common/ChangePassword"));
const BranchManagement = lazy(() => import("../pages/setting/BranchManagement"));
const TimeframeManagement = lazy(() => import("../pages/setting/TimeframeManagement"));
const GradeManagement = lazy(() => import("../pages/setting/GradeManagement"));
const SubjectManagement = lazy(() => import("../pages/setting/SubjectManagement"));
const TeacherManagement = lazy(() => import("../pages/setting/TeacherManagement"));
const CourseManagement = lazy(() => import("../pages/setting/CourseManagement"));
const UserManagement = lazy(() => import("../pages/setting/UserManagement"));
const EmailSetting = lazy(() => import("../pages/setting/EmailSetting"));
const ClassSchedule = lazy(() => import("../pages/schedule/ClassSchedule"));
const TeacherInfo = lazy(() => import("../pages/teacher/TeacherInfo"));
const GradeTimetable = lazy(() => import("../pages/timetable/GradeTimetable"));
const TeacherTimetable = lazy(() => import("../pages/timetable/TeacherTimetable"));
const TimetableCourseEdit = lazy(() => import("../pages/timetable/TimetableCourseEdit"));
const TimetableSetting = lazy(() => import("../pages/timetable/TimetableSetting"));

const allUserTypes = ["Admin", "Manager", "Employee", "Department"];
const adminManagerUserTypes = ["Admin", "Manager"];
const adminManagerEmployeeUserTypes = ["Admin", "Manager", "Employee"];

export const protectedRoutes = [
  {
    path: "/",
    element: <Dashboard />,
    name: "Dashboard",
  },
  {
    path: "/changePassword",
    element: <ChangePassword />,
    name: "Change Password",
    userTypes: allUserTypes,
    withLayout: false,
  },
  {
    path: "/branch/setting",
    element: <BranchManagement />,
    name: "Branch",
    userTypes: adminManagerUserTypes,
  },
  {
    path: "/timeframe/setting",
    element: <TimeframeManagement />,
    name: "Timeframe",
    userTypes: adminManagerEmployeeUserTypes,
  },
  {
    path: "/grade/setting",
    element: <GradeManagement />,
    name: "Grade",
    userTypes: adminManagerEmployeeUserTypes,
  },
  {
    path: "/subject/setting",
    element: <SubjectManagement />,
    name: "Subject",
    userTypes: adminManagerEmployeeUserTypes,
  },
  {
    path: "/teacher/setting",
    element: <TeacherManagement />,
    name: "teacher",
    userTypes: adminManagerEmployeeUserTypes,
  },
  {
    path: "/course/setting",
    element: <CourseManagement />,
    name: "Course",
    userTypes: adminManagerEmployeeUserTypes,
  },
  {
    path: "/course/schedule",
    element: <ClassSchedule />,
    name: "Class Schedule",
    userTypes: adminManagerEmployeeUserTypes,
  },
  {
    path: "/user/setting",
    element: <UserManagement />,
    name: "User",
    userTypes: adminManagerUserTypes,
  },
  {
    path: "/email/setting",
    element: <EmailSetting />,
    name: "Email Setting",
    userTypes: adminManagerUserTypes,
  },
  {
    path: "/teacher/info",
    element: <TeacherInfo />,
    name: "Teacher Information",
    userTypes: allUserTypes,
  },
  {
    path: "/timetable/grade",
    element: <GradeTimetable />,
    name: "GradeTimetable",
    userTypes: allUserTypes,
  },
  {
    path: "/timetable/teacher",
    element: <TeacherTimetable />,
    name: "TeacherTimetable",
    userTypes: allUserTypes,
  },
  {
    path: "/timetable/setting",
    element: <TimetableSetting />,
    name: "Timetable Setting",
    userTypes: adminManagerEmployeeUserTypes,
  },
  {
    path: "/timetable/course/:uuid/edit",
    element: <TimetableCourseEdit />,
    name: "Timetable Course Edit",
    userTypes: adminManagerEmployeeUserTypes,
  },
  
];
